import { styled } from '@mui/material';
import { typographyStyles } from '../../../scan/components/DataGridScanStatusField/styles';

export const Wrapper = styled('div')`
  display: inline-flex;
  flex-direction: row;
  height: 2.5rem;
  background: #f6f6f6;
  border-radius: 12px;
  text-align: center;
  align-items: center;
`;

export const Item = styled('div')<{
  active?: boolean;
}>(({ theme, active }) => ({
  display: 'inline-flex',
  flexDirection: 'row',
  width: 'fit-content',
  height: '2.5rem',
  padding: '0 1rem',
  background: active ? '#353535' : 'transparent',
  color: active ? '#fff' : '#878787',
  borderRadius: '10px',
  fontWeight: 700,
  cursor: 'pointer',
  alignItems: 'center',
  transition: theme.transitions.create(['background', 'color']),
  ...typographyStyles(theme, true),
}));

export const ItemIcon = styled('div')`
  line-height: 0;
  margin-right: 8px;
  display: flex;
  align-items: center;
`;
